import React from 'react'
import { useSelector } from 'react-redux'
import '../../../components/pcrHeader/PCRHeader.component.css'
import Header from '../../../components/header/Header.component'
import { getNotificationCenterSelector } from '../../notificationCenter/selectors'
import { useOfflineStatus } from '../../../utilities/isOnline.util'
import { getSelectedFlagIdSelector, getSelectedFlagDetailSelector } from '../qaAddendums/selectors'
import { isFlagHeaderBlackedOut } from '../utils/qaFlagBlackout.util'

interface QAFlagsHeaderprops {
  showMenuButton: boolean
}

const QaFlagHeader: React.FC<QAFlagsHeaderprops> = ({ showMenuButton }) => {
  const flagId = useSelector(getSelectedFlagIdSelector)
  const selectedFlagDetail = useSelector(getSelectedFlagDetailSelector)
  const { items: notifications } = useSelector(getNotificationCenterSelector)
  const hasUnreadNotifications = notifications.some((item) => !item.isRead)
  const isOfflineStatus = useOfflineStatus()
  const showMenu = showMenuButton && hasUnreadNotifications && !isOfflineStatus

  const flagDetail =
    selectedFlagDetail && flagId && String(selectedFlagDetail.flagId) === flagId ? selectedFlagDetail : null

  const isHeaderBlackedOut = flagDetail ? isFlagHeaderBlackedOut(flagDetail.lockType, 'S') : false
  const patientName = !isHeaderBlackedOut ? flagDetail?.patientName?.trim() : undefined
  const title = patientName ? (
    <h6 className='name-header'>
      <b>{patientName}</b>
    </h6>
  ) : (
    ''
  )

  return <Header isPHI title={title} showMenuButton={showMenu} />
}

export default QaFlagHeader
